import gql from 'graphql-tag'

export default () => {
	return {
		query: gql`
			{
				contacts_categories(order_by: { order: asc }) {
					id
					category_name
					country {
						code
					}
					order
					active
				}
			}
		`,
		update(data) {
			return data.contacts_categories.map(item => ({
				id: item.id,
				category_name: item.category_name,
				countryCode: item.country.code,
				order: item.order,
				edit: true,
				active: item.active
			}))
		}
	}
}
